// SPDX-License-Identifier: AGPL-3.0-or-later
// KONVO: the rules behind the last-message line on a Chats panel row: which of
// the messages we hold is the newest, and which chats still need one fetched.

import {compare} from '@konvo/snowflake/src/SnowflakeUtils';

interface Identified {
	readonly id: string;
}

/** The newer of two messages by snowflake, or whichever one exists. */
export function pickNewerMessage<T extends Identified>(
	first: T | null | undefined,
	second: T | null | undefined,
): T | null {
	if (!first) return second ?? null;
	if (!second) return first;
	return compare(first.id, second.id) >= 0 ? first : second;
}

export interface PreviewFetchInput {
	/** Newest message the server knows about, from the channel record. */
	lastMessageId: string | null;
	/** Newest message already held for this chat, from any source. */
	knownMessageId: string | null;
	/** Newest message already asked for, so an unreadable one is not asked for twice. */
	requestedMessageId: string | null;
}

export function needsPreviewFetch({lastMessageId, knownMessageId, requestedMessageId}: PreviewFetchInput): boolean {
	if (!lastMessageId) return false;
	if (knownMessageId != null && compare(knownMessageId, lastMessageId) >= 0) return false;
	if (requestedMessageId != null && compare(requestedMessageId, lastMessageId) >= 0) return false;
	return true;
}
